import type { FeedbackFormValues } from '@/components/form/FeedbackForm';

type RatingFieldKey = keyof Pick<
  FeedbackFormValues,
  | 'match_with_company'
  | 'match_with_role'
  | 'match_with_team'
  | 'match_with_culture'
  | 'match_with_career'
  | 'match_with_tech'
  | 'match_with_interviewers'
>;

type CommentFieldKey = keyof Pick<
  FeedbackFormValues,
  | 'match_with_company_comment'
  | 'match_with_role_comment'
  | 'match_with_team_comment'
  | 'match_with_culture_comment'
  | 'match_with_career_comment'
  | 'match_with_tech_comment'
  | 'match_with_interviewers_comment'
>;

interface FeedbackRatingField {
  ratingField: RatingFieldKey;
  commentField: CommentFieldKey;
  showCommentField: string;
  labelKey: string;
}

export const FEEDBACK_RATING_FIELDS: readonly FeedbackRatingField[] = [
  {
    ratingField: 'match_with_company',
    commentField: 'match_with_company_comment',
    showCommentField: 'show_company_comment',
    labelKey: 'MATCH_WITH_COMPANY',
  },
  {
    ratingField: 'match_with_role',
    commentField: 'match_with_role_comment',
    showCommentField: 'show_role_comment',
    labelKey: 'MATCH_WITH_ROLE',
  },
  {
    ratingField: 'match_with_team',
    commentField: 'match_with_team_comment',
    showCommentField: 'show_team_comment',
    labelKey: 'TEAM_LABEL',
  },
  {
    ratingField: 'match_with_culture',
    commentField: 'match_with_culture_comment',
    showCommentField: 'show_culture_comment',
    labelKey: 'CULTURE',
  },
  {
    ratingField: 'match_with_career',
    commentField: 'match_with_career_comment',
    showCommentField: 'show_career_comment',
    labelKey: 'CAREER-OPPORTUNITIES',
  },
  {
    ratingField: 'match_with_tech',
    commentField: 'match_with_tech_comment',
    showCommentField: 'show_tech_comment',
    labelKey: 'TECH_USED',
  },
  {
    ratingField: 'match_with_interviewers',
    commentField: 'match_with_interviewers_comment',
    showCommentField: 'show_interviewers_comment',
    labelKey: 'INTERVIEWERS',
  },
] as const;
